import { Component, inject } from '@angular/core';
import { find, get } from 'lodash';
import { AuthenticationService } from '@services/account/authentication.service';
import { BaseTopBarComponent } from '@components/abstract/base-top-bar.component';
import { CookieService } from 'ngx-cookie-service';
import { DOCUMENT } from '@angular/common';
import { ICommunityService } from '@tokens/injection.tokens';
import { Inject } from '@angular/core';
import { LanguageService } from '@services/layout/language.service';
import { MenuItem } from '@models/layout/menu.model';
import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { communityModules } from '@database/community-modules';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent extends BaseTopBarComponent implements OnInit {
  menuItems: MenuItem[] = communityModules;

  communityService = inject(ICommunityService);
  hideSubMenuOptions: Array<string> = [];
  brookdaleInd = false;

  // HeadLess
  headLess = false;

  constructor(
    @Inject(DOCUMENT) document: any,
    router: Router,
    languageService: LanguageService,
    cookiesService: CookieService,
    authenticationService: AuthenticationService
  ) {
    super(
      document,
      router,
      languageService,
      cookiesService,
      authenticationService
    );

    this.unsubscribe.push(
      this.communityService.model$.subscribe(community => {
        if (community) {
          const corporationFlags = get(community, 'corporation.flags');

          const optionsToHide = [
            { name: 'CLUB_FEATURE', label: 'Clubs' },

            { name: 'CUSTOM_CALENDAR', label: 'Prints' }, //CHANGES TO 2 NEW FLAGS BELOW
            //{ name: 'CUSTOM_CALENDAR_PRINTING', label: 'Prints' },
            {
              name: 'CUSTOM_CALENDAR_EXPERIENCES',
              label: 'Calendar Experiences',
            },

            { name: 'QUALITY_OF_LIFE', label: 'Quality of Life' },
            { name: 'CALENDAR', label: 'Calendar' },
            { name: 'CONTENT_PLATFORM', label: 'Content' },
            { name: 'SALES_PLATFORM', label: 'Sales Tools' },
            { name: 'SURVEY_PLATFORM', label: 'Feedback' },
            { name: 'TRANSPORTATION_WEB', label: 'Transportation' },
            { name: 'DINING_KIOSK', label: 'Kiosk' },
            { name: 'DINING_KIOSK', label: 'Dining Calendar' },
            { name: 'COMPLIANCE', label: 'Compliance (Beta)' },
            { name: 'PREMIUM_CONTENT', label: 'Spiro 100' },
            { name: 'PREMIUM_CONTENT', label: 'Fit Minds' },
            { name: 'PREMIUM_CONTENT', label: 'Wowzitude' },
            { name: 'PREMIUM_CONTENT', label: 'MasterClass' },
          ];
          optionsToHide.forEach(option => {
            const flag = find(corporationFlags, { name: option.name });
            if ((flag && !flag?.value) || flag === undefined) {
              this.hideSubMenuOptions.push(option.label);
            }
          });

          if (community.corporation.id === environment.brookdaleCorpId) {
            this.brookdaleInd = true;
            this.hideSubMenuOptions.push('Family');
            this.hideSubMenuOptions.push('Announcements');
            this.hideSubMenuOptions.push('Newsletter');
            this.hideSubMenuOptions.push('Messages');
            this.hideSubMenuOptions.push('Reports');
          }
        }
      })
    );

    const segments = this.router.url.split('/');
    this.headLess = segments.indexOf('headless') != -1;
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }
}
